module.exports = __webpack_public_path__ + "static/media/milli-i.fb0d16b8.svg";